import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import productimage1 from '../../images/product-img-1.jpg'
import productimage2 from '../../images/product-img-2.jpg'
import productimage3 from '../../images/product-img-3.jpg'
import productimage4 from '../../images/product-img-4.jpg'
import productimage5 from '../../images/product-img-5.jpg'
import { MagnifyingGlass } from "react-loader-spinner";
import ScrollToTop from "../ScrollToTop";
import CartItem from "../../Component/CartItem";
import { CartContext, UserContext, websiteContext } from "../../App";
import api from "../../api";
import CartSummary from "../../Component/CartSummary";
import { v4 as uuidv4 } from "uuid";
import { convertPercentToAmount } from "../../reducers/utils";

const ShopCart = () => {

  const {user} = useContext(UserContext)
	const {cart, cartDispatch} = useContext(CartContext)
  const order_id = "ORD-" + uuidv4().slice(0, 8).toUpperCase();
  const {websiteDetails} = useContext(websiteContext)

console.log("Website",websiteDetails)
  const setProductQuantity = async (id, quantity) => {
		const item = cart?.products.find(p => p.id == id)
		if (quantity > item?.balance){
			return toast.error("No More Stock Available")
			console.log(item.balance,"out of stock");
		}
		if (quantity < 1) {
			cartDispatch({type: "REMOVE_PRODUCT", payload: id})
			api.removeProductFromCart(id);
			return;
			// if (user){ 
			// 	api.removeProductFromCart(id)
			// }
		}
			cartDispatch({type: "SET_PRODUCT_QUANTITY", payload: {id, quantity}})
			 api.patchCart(id, quantity)
	}


    const removeProduct = async (id, quantity) => {

			cartDispatch({type: "REMOVE_PRODUCT", payload: id})
			api.removeProductFromCart(id);
			return;
			// cartDispatch({type: "SET_PRODUCT_QUANTITY", payload: {id, quantity}})
			//  api.patchCart(id, quantity)
	}

  	const handleCheckout = async (discount,chargesTotal) => {
		// const user = api.getUser()
		const key = "orderData" 
		const value ={
			order_id,
			products:cart.products,
			amount:cart.total,
			couponAmount:discount,
			delCharge:chargesTotal,
		}
		const resp = await api.createSession(key,value)
		 const updatedData = {
			couponAmount:discount,
			delCharge:chargesTotal
			  }
		const updatedCart = await api.updateCart(updatedData);
		// console.log("session Data",resp);
		// setShowCheckoutModal(true)
	}

   // loading
   const [loaderStatus, setLoaderStatus] = useState(true);
   useEffect(() => {
     setTimeout(() => {
       setLoaderStatus(false);
     }, 1500);
   }, []);
 


   	if (cart?.products?.length == 0) {
		return (
			<main className="h-screen flex flex-col items-center text-center my-14 p-4">
				<h1>Your Shopping Cart is Empty</h1>
				<Link to="/Shop" className="btn btn-primary">
          Continue Shopping
        </Link>
			</main>
		)
	}

  return (
    <div>
      <div>
      {loaderStatus ? (
        <div className="loader-container">
          {/* <PulseLoader loading={loaderStatus} size={50} color="#0aad0a" /> */}
          <MagnifyingGlass
          visible={true}
          height="100"
          width="100"
          ariaLabel="magnifying-glass-loading"
          wrapperStyle={{}}
          wrapperclassName="magnifying-glass-wrapper"
          glassColor="#c0efff"
          color="#0aad0a"
          />
        </div>
      ) : (
        <>
         <>
            <ScrollToTop/>
            </>
      <>
        <div>
          {/* section*/}
        
          {/* section */}
          <section className="mb-lg-14 mb-8 mt-8">
            <div className="container">
              {/* row */}
              <div className="row">
                <div className="col-12">
                  {/* card */}
                  <div className="card py-1 border-0 mb-8">
                    <div>
                      <h1 className="fw-bold">Shop Cart</h1>
                      {/* <p className="mb-0">Shopping in 382480</p> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* row */}
              <div className="row">
                <div className="col-lg-8 col-md-7">
                  <div className="py-3">
                    {/* alert */}
                    {/* <div className="alert alert-danger p-2" role="alert">
                      You’ve got FREE delivery. Start{" "}
                      <Link to
                      ="#!" className="alert-link">
                        checkout now!
                      </Link>
                    </div> */}
                    <ul className="list-group list-group-flush">

                      {cart?.products.map((product=>
                      <CartItem
                      key={product?.id}
                      title={product?.title}
                      image={product?.image?.split(";")[0]}
                      price={product?.price}
                      quantity={product?.quantity}
                      setQuantity={qty =>setProductQuantity(product?.id,qty)}
                      onRemove={qty=> removeProduct(product?.id,qty)}
                      type={product?.type}
                      />
                      ))}
                      
                    </ul>
                    {/* btn */}
                    <div className="d-flex justify-content-between mt-4">
                      <Link to="/Shop" className="btn btn-primary">
                        Continue Shopping
                      </Link>
                      {/* <Link to="#!" className="btn btn-dark">
                        Update Cart
                      </Link> */}
                    </div>
                  </div>
                </div>

                {/* CartSummary */}
                <CartSummary
                subtotal={cart?.total}
                charges={[
                websiteDetails?.del_on_cart ==  true 
                ?{name: "Delivery Charges", 
                  amount: websiteDetails.advalorem_specific == "A" 
                  ?Number(cart.total?.toFixed(2)) > Number(websiteDetails.del_free_val) ? 0 : Number(convertPercentToAmount(cart.total?.toFixed(2),websiteDetails.eff_tax?.toFixed(2))) ?? 0
                  :Number(cart.total?.toFixed(2)) > Number(websiteDetails.del_free_val) ? 0 : Number(websiteDetails.eff_tax?.toFixed(2)) ?? 0}
                :{name: "Delivery Charges", amount: cart.products.map(p=>(p?.delCharge ?? 0))}
                ]}
                discounts={[]}
                onCheckout={handleCheckout}
                orderId={order_id}
                />

                {/* <div className="col-12 col-lg-4 col-md-5">
                  
                  <div className="mb-5 card mt-6">
                    <div className="card-body p-6">
                      
                      <h2 className="h5 mb-4">Summary</h2>
                      <div className="card mb-2">
                        
                        <ul className="list-group list-group-flush">
                          
                          <li className="list-group-item d-flex justify-content-between align-items-start">
                            <div className="me-auto">
                              <div>Item Subtotal</div>
                            </div>
                            <span>$70.00</span>
                          </li>
                          
                          <li className="list-group-item d-flex justify-content-between align-items-start">
                            <div className="me-auto">
                              <div>Service Fee</div>
                            </div>
                            <span>$3.00</span>
                          </li>
                          
                          <li className="list-group-item d-flex justify-content-between align-items-start">
                            <div className="me-auto">
                              <div className="fw-bold">Subtotal</div>
                            </div>
                            <span className="fw-bold">$67.00</span>
                          </li>
                        </ul>
                      </div>
                      <div className="d-grid mb-1 mt-4">
                        
                        <button
                          className="btn btn-primary btn-lg d-flex justify-content-between align-items-center"
                          type="submit"
                        >
                          Go to Checkout <span className="fw-bold">$67.00</span>
                        </button>
                      </div>
                      
                      <p>
                        <small>
                          By placing your order, you agree to be bound by the
                          Freshcart <Link to
                          ="#!">Terms of Service</Link>
                          and <Link to
                          ="#!">Privacy Policy.</Link>{" "}
                        </small>
                      </p>
                      
                      <div className="mt-8">
                        <h2 className="h5 mb-3">Add Promo or Gift Card</h2>
                        <form>
                          <div className="mb-2">
                            
                            <label
                              htmlFor="giftcard"
                              className="form-label sr-only"
                            >
                              Email address
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="giftcard"
                              placeholder="Promo or Gift Card"
                            />
                          </div>
                          
                          <div className="d-grid">
                            <button
                              type="submit"
                              className="btn btn-outline-dark mb-1"
                            >
                              Redeem
                            </button>
                          </div>
                          <p className="text-muted mb-0">
                            {" "}
                            <small>Terms &amp; Conditions apply</small>
                          </p>
                        </form>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </section>
        </div>
      </>
    </>
    )}
  </div>
    </div>
  );
};

export default ShopCart;
